import { __awaiter, __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DepositWalletModalComponent } from "../deposit-wallet-modal/deposit-wallet-modal.component";
import { WithdrawWalletModalComponent } from "../withdraw-wallet-modal/withdraw-wallet-modal.component";
import { ComponentService } from "../../../services/component.service";
import { UpdateUserDataWalletModalComponent } from '../update-user-data-wallet-modal/update-user-data-wallet-modal.component';
import { WebClientService } from '../../../services/webclient-settings.service';
import { AuthService } from "../../../services/auth.service";
import { DepositOriginService } from '../../../services/deposit-origin.service';
/**
 * Coin Details Component
 */
let CoinDetailsComponent = class CoinDetailsComponent {
    constructor(httpClient, route, sanitizer, themeService, router, compService, webSettingsService, auth, depositOriginService) {
        this.httpClient = httpClient;
        this.route = route;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.compService = compService;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.depositOriginService = depositOriginService;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.secondaryColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.searchCrypto = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.transactions = [];
        this.allTransactions = [];
        this.slice = 0;
        this.hasTransactions = false;
        this.coin = localStorage.getItem('coin');
        this.walletId = localStorage.getItem('walletId');
        this.isFiat = localStorage.getItem('isFiat');
        this.activeCurrency = localStorage.getItem('defaultCurrency').toLowerCase();
        this.price = {};
        this.priceChange = {};
        this.priceInBtc = {};
        this.accountData = [];
        this.walletData = [];
        this.loaded = false;
        this.pricesLoaded = false;
        this.transactionsLoaded = false;
        this.priceChart = [];
        this.dailyPrices = [];
        this.chartColor = "black";
        this.appRegion = this.webSettingsService.getWebSetting('APP_REGION');
        this.showMoreButtonClicked = false;
        this.auth.fetchUser().then(result => {
            this.user = JSON.parse(localStorage.getItem('user'));
            if (!this.user) {
                this.router.navigateByUrl('');
            }
        });
        if (!localStorage.getItem('walletId') || !localStorage.getItem('coin')) {
            this.router.navigateByUrl('wallet/transactions');
        }
        this.getAccounts();
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            this.sliceFromSetting = Number(this.webSettingsService.getWebSetting('WALLET.PAGINATION.NUMBER_OF_TRANSACTIONS'));
        });
    }
    ngOnInit() {
        this.getWalletAndPrices();
        this.getTransactions();
        this.intervalId = setInterval(() => {
            this.getWalletAndPrices();
            this.getTransactions();
        }, 15000);
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    reloadPrices() {
        this.getWalletAndPrices();
    }
    reloadTransactions() {
        this.getTransactions();
    }
    showMore() {
        this.showMoreButtonClicked = true;
        this.slice = this.slice + this.sliceFromSetting;
        this.getTransactions();
    }
    searchCryptocurrency() {
        this.transactions = this.allTransactions;
        this.transactions = this.allTransactions.filter(transaction => (((transaction.currency.name.toLowerCase().includes(this.searchCrypto.toLowerCase())) || transaction.currency.verboseId.toLowerCase().includes(this.searchCrypto.toLowerCase()))));
    }
    getAccounts() {
        this.httpClient.get('wallet/getaccount').subscribe((data) => {
            if (data['accounts'] && data['accounts']['verboseId']) {
                this.accountData = data['accounts'];
            }
        });
    }
    getTransactions() {
        this.transactionsLoaded = false;
        const limit = this.sliceFromSetting + this.slice;
        this.httpClient.get('wallet/getwallettransactions?customerWalletId=' + this.walletId + '&page=0&limit=' + limit).subscribe((data) => {
            var _a, _b;
            this.paginationData = data['paginationData'];
            this.hasTransactions = true;
            this.transactions = data['transactions'];
            (_a = this.transactions) === null || _a === void 0 ? void 0 : _a.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
            this.allTransactions = data['transactions'];
            (_b = this.allTransactions) === null || _b === void 0 ? void 0 : _b.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
            this.transactionsLoaded = true;
            this.showMoreButtonClicked = false;
        });
    }
    getWalletAndPrices() {
        this.pricesLoaded = false;
        this.httpClient.get('market/getdailypricechanges?currency=' + this.coin).subscribe((data) => {
            if (this.isFiat === 'false') {
                this.priceChart = data['prices'];
                this.dailyPrices = this.getDailyPrices();
                let priceTrend = this.getPriceTrend();
                this.chartColor = priceTrend == "up" ? "green" : (priceTrend == "down" ? "red" : "black");
            }
            this.httpClient.get('wallet/getwallet?customerWalletId=' + this.walletId).subscribe((data) => {
                this.walletData = data['wallet'];
                this.httpClient.get('market/pricesforwallet').subscribe((data) => {
                    this.price = this.isFiat === 'false' ? data[this.activeCurrency + '_prices'][this.coin] : 1;
                    this.priceInBtc = data[this.activeCurrency + '_prices']['btc'];
                    this.httpClient.get('market/prices/changesforwallet').subscribe((data) => {
                        this.priceChange = data[this.coin];
                        this.loaded = true;
                        this.pricesLoaded = true;
                    });
                });
            });
        });
    }
    getDailyPrices() {
        const dailyPrices = [];
        if (this.priceChart && this.priceChart.length > 0) {
            this.priceChart.forEach(price => {
                dailyPrices.push({ data: price });
            });
        }
        return dailyPrices;
    }
    getPriceTrend() {
        if (this.priceChart && this.priceChart.length > 0) {
            const startDayPrice = this.priceChart[0];
            const endDayPrice = this.priceChart.at(-1);
            if (endDayPrice > startDayPrice) {
                return 'up';
            }
            else if (endDayPrice < startDayPrice) {
                return 'down';
            }
            else {
                return 'same';
            }
        }
    }
    deposit() {
        if (!this.user.newDataPopulated && this.appRegion != 'EU') {
            this.compService.openModal(UpdateUserDataWalletModalComponent);
        }
        else {
            this.compService.openModal(DepositWalletModalComponent, {
                accountData: this.accountData,
                walletData: this.walletData
            });
        }
    }
    withdraw() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.walletData.spendableTotal > 0) {
                if (yield this.depositOriginService.gate(() => this.withdraw())) {
                    return;
                }
                this.compService.openModal(WithdrawWalletModalComponent, {
                    accountData: this.accountData,
                    walletData: this.walletData
                });
            }
            if (!this.user.newDataPopulated && this.appRegion != 'EU') {
                this.compService.openModal(UpdateUserDataWalletModalComponent);
            }
        });
    }
    onSeriesAdded(e) {
        if (e.args.series) {
            e.args.series.tooltipTemplate = this.valueTooltip;
        }
    }
};
CoinDetailsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: ComponentService },
    { type: WebClientService },
    { type: AuthService },
    { type: DepositOriginService }
];
__decorate([
    ViewChild('valueTooltip', { static: true })
], CoinDetailsComponent.prototype, "valueTooltip", void 0);
CoinDetailsComponent = __decorate([
    Component({
        selector: 'ecd-coin-details',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./coin-details.component.html")).default
    })
], CoinDetailsComponent);
export { CoinDetailsComponent };
